import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { Plus, Minus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Sirve si recién empiezo o si ya tengo años corriendo?',
    a: 'Sí. El Sistema Running Pro está diseñado para funcionar en cualquier nivel. El Tomo 1 empieza con un diagnóstico que calibra todo el sistema a tu punto de partida real. Un principiante y un corredor de 5 años de experiencia van a encontrar herramientas específicas y aplicables para su nivel.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de tu compra recibís un correo con el acceso a los 6 tomos y los 6 bonos en formato PDF. Podés descargarlo y usarlo desde el celular, la tablet o la computadora. Sin apps, sin plataformas, sin contraseñas que vencen.'
  }, {
    q: '¿Funciona para asfalto y para trail?',
    a: 'Sí. El sistema está construido sobre principios fisiológicos y biomecánicos que aplican a cualquier tipo de superficie. Donde hay diferencias específicas entre asfalto y trail, el sistema las señala y da la variante correspondiente para cada contexto.'
  }, {
    q: '¿Necesito equipamiento especial o conocimiento previo?',
    a: 'No. El Sistema Running Pro fue diseñado específicamente para el corredor que no tiene entrenador, no tiene reloj de alta gama y no tiene formación técnica previa. Todo lo que necesitás es tu cuerpo, tus zapatillas y este sistema.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total sin preguntas. Si abrís los tomos, los revisás y sentís que no es lo que esperabas, escribís a soporte.tumanualdigital@gmail.com y devolvemos el 100% del pago. Sin formularios, sin períodos de espera, sin drama.'
  }, {
    q: '¿Puedo aplicarlo con solo 3 o 4 horas semanales de entrenamiento?',
    a: 'Sí. El sistema fue construido alrededor de la realidad del corredor con vida real. El microciclo de 3 días del Tomo 2 y el Kit Anti-Errores del Runner Ocupado del Bono 6 están específicamente diseñados para maximizar el resultado en ventanas de tiempo pequeñas e irregulares.'
  }];
  return <section className="py-8 md:py-20 px-4 max-w-3xl mx-auto" data-id="element-114">
      <FadeIn data-id="element-115">
        <h2 className="text-2xl md:text-5xl font-black text-[#0f172a] text-center mb-6 md:mb-14 flex items-center justify-center gap-3 md:gap-4" data-id="element-116">
          <span className="text-3xl md:text-5xl drop-shadow-[0_0_15px_rgba(34,197,94,0.2)]" data-id="element-117">
            ❓
          </span>{' '}
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2.5 md:space-y-4" data-id="element-118">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-119" />)}
        </div>
      </FadeIn>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div className={`border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'bg-white border-[#22c55e] shadow-[0_5px_15px_rgba(34,197,94,0.1)]' : 'bg-white border-[#e2e8f0] hover:border-[#22c55e]/50 shadow-sm'}`} data-id="element-120">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-4 md:px-6 py-4 md:py-6 text-left flex justify-between items-center focus:outline-none gap-3" data-id="element-121">
        <span className={`font-black text-sm md:text-xl pr-2 md:pr-4 transition-colors ${isOpen ? 'text-[#16a34a]' : 'text-[#0f172a]'}`} data-id="element-122">
          {question}
        </span>
        <div className={`shrink-0 p-1.5 md:p-2 rounded-full transition-colors ${isOpen ? 'bg-[#22c55e]/20 text-[#16a34a]' : 'bg-[#f1f5f9] text-[#475569]'}`} data-id="element-123">
          {isOpen ? <Minus className="w-4 h-4 md:w-5 md:h-5" data-id="element-124" /> : <Plus className="w-4 h-4 md:w-5 md:h-5" data-id="element-125" />}
        </div>
      </button>
      <AnimatePresence data-id="element-126">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-127">
            <div className="px-4 md:px-6 pb-4 md:pb-6 pt-1 md:pt-2" data-id="element-128">
              <p className="text-[#475569] leading-relaxed text-sm md:text-lg font-medium" data-id="element-129">
                {answer}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}